import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { FloatLabelType, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SelectionOptions } from '@app/shared/interfaces/selection-option';

@Component({
  selector: 'app-selection-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatChipsModule,
    MatOptionModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
  ],
  templateUrl: './selection-input.component.html',
  styleUrl: './selection-input.component.scss',
})
export class SelectionInputComponent implements OnInit {
  @Input() control!: FormControl;

  @Input() options!: SelectionOptions;
  @Input() label: string = '';
  @Input() floatLabel: FloatLabelType = 'auto';

  @Input() isDisabled: boolean = false;
  @Input() noSelection: boolean = false;

  @Output() selectedOption = new EventEmitter<string | null>();

  ngOnInit() {
    return;
  }

  onOptionSelected(event: any) {
    this.selectedOption.emit(event.value);
  }
}
